<template>
  <div class="organization-form-block">
    <div class="row">
      <internal-comment-block
        v-model="form.application.internal_comment"
        v-if="canShowInternalComment"
        :form="form"
      />
      <div
        v-if="visibleOrganizationSubjectField"
        :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.ORGANIZATION_SUBJECT, PassSectionsEnum.organization)"
      >
        <organization-subject-input
          v-model="organization.subject_id"
          :input-label="fieldTitle(OrganizationSectionFieldAliases.ORGANIZATION_SUBJECT, PassSectionsEnum.organization)"
          :input-hint="fieldHint(OrganizationSectionFieldAliases.ORGANIZATION_SUBJECT, PassSectionsEnum.organization)"
          :form="form"
          :errors="errors"
          :items="organizationSubjects"
          :nationalities-list="nationalitiesList"
          :organization-subjects-residency="organizationSubjectsResidency"
          :selected-nationality="selectedNationality"
          :disabled="disabledSubject"
          @change="change($event); cleanPrevValues(); hidePersonalOrganizationFields()"
        >
          <template v-slot:selectNationality>
            <b-dropdown
              :id="'organization-subject-input'"
              toggle-class="right-border-radius-unset right-border-none subject-input-dropdown"
              :disabled="disabledSubject"
              ref="dropdown"
              class="subject-input-residency-list"
            >
              <template #button-content>
                <img
                  v-if="selectedNationality"
                  class="flag_img subject-input-flag"
                  :src="selectedNationalityImage"
                  :alt="selectedNationality.iso2"
                />
                <slot name="arrow-icon" :open="nationalityListIsOpen">
              <span class="vti__dropdown-arrow subject-input-arrow" v-if="isView === false">
                {{ nationalityListIsOpen ? '▲' : '▼' }}
              </span>
                </slot>
              </template>
              <template v-for="(nationality, key) in nationalities">
                <b-dropdown-item
                  :key="key"
                  :style="{cursor: 'pointer'}"
                  @click="changeNationality(nationality)"
                >
                  <img class="flag_img" :src="iconsPath + nationality.iso2 + '.svg'" alt="" width="20"/>
                  <span style="margin-left: 5px"
                  ><strong>{{ nationality.full_name }}</strong></span
                  >
                </b-dropdown-item>
              </template>
              <slot name="lastItems"></slot>
            </b-dropdown>
          </template>
        </organization-subject-input>
      </div>
      <div
        v-if="visibleOrganizationNameField"
        :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.ORGANIZATION_NAME, PassSectionsEnum.organization)"
      >
        <organization-name-input
          v-model="organization.name"
          :form="form"
          :errors="errors"
          :typeahead="typeaheadOrganizationName"
          :select-typeahead="selectTypeaheadOrganization"
          :nationalities-list="nationalitiesList"
          :location-name="locationName"
          :disabled="disabledName"
          :input-label="organizationNameInputLabel"
          @switch-location-name="switchLocationName"
          @change="change($event); cleanContactFields()"
        />
      </div>
      <div
        v-if="visibleOrganizationInnField"
        :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.ORGANIZATION_INN, PassSectionsEnum.organization)"
      >
        <organization-inn-input
          v-model="organization.inn"
          :input-label="fieldTitle(OrganizationSectionFieldAliases.ORGANIZATION_INN, PassSectionsEnum.organization)"
          :input-hint="fieldHint(OrganizationSectionFieldAliases.ORGANIZATION_INN, PassSectionsEnum.organization)"
          :form="form"
          :errors="errors"
          :typeahead="typeaheadOrganizationInn"
          :select-typeahead="selectTypeaheadOrganization"
          :organization-subjects-residency="organizationSubjectsResidency"
          :disabled="disabledInn"
          @change="change($event); cleanContactFields()"
        />
      </div>
      <div
        v-if="visibleOrganizationAddressField"
        :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.ORGANIZATION_ADDRESS, PassSectionsEnum.organization)"
      >
        <organization-address-input
          v-model="organization.address"
          :input-label="fieldTitle(OrganizationSectionFieldAliases.ORGANIZATION_ADDRESS, PassSectionsEnum.organization)"
          :input-hint="fieldHint(OrganizationSectionFieldAliases.ORGANIZATION_ADDRESS, PassSectionsEnum.organization)"
          :form="form"
          :errors="errors"
          :typeahead="typeaheadOrganizationAddress"
          :prevValue="prevAddress"
          :disabled="disabledAddressField"
          @change="change"
          ref="organizationName"
        />
      </div>
      <!--    <div class="col-md-12">-->
      <!--      <organization-fiz-address-input-->
      <!--          v-model="organization.fiz_address"-->
      <!--          :form="form"-->
      <!--          :errors="errors"-->
      <!--          :typeahead="typeaheadOrganizationFizAddress"-->
      <!--          :prevValue="prevAddress"-->
      <!--          :disabled="disabledOrganizationField"-->
      <!--          @change="change('organization fizAddress')"-->
      <!--          @input="change('organization fizAddress')"-->
      <!--      />-->
      <!--    </div>-->
      <div
        v-if="visibleOrganizationPhoneField"
        :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.ORGANIZATION_PHONE, PassSectionsEnum.organization)"
      >
        <organization-phone-input
          v-model="organization.phone"
          :input-label="fieldTitle(OrganizationSectionFieldAliases.ORGANIZATION_PHONE, PassSectionsEnum.organization)"
          :input-hint="fieldHint(OrganizationSectionFieldAliases.ORGANIZATION_PHONE, PassSectionsEnum.organization)"
          :form="form"
          :errors="errors"
          :disabled="disabledPhone"
          @change="change"
        />
      </div>
      <div
        v-if="visibleOrganizationEmailField"
        :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.ORGANIZATION_EMAIL, PassSectionsEnum.organization)"
      >
        <organization-email-input
          v-model="organization.email"
          :input-label="fieldTitle(OrganizationSectionFieldAliases.ORGANIZATION_EMAIL, PassSectionsEnum.organization)"
          :input-hint="fieldHint(OrganizationSectionFieldAliases.ORGANIZATION_EMAIL, PassSectionsEnum.organization)"
          :form="form"
          :errors="errors"
          :disabled="disabledEmail"
        />
      </div>
      <div
        v-if="visibleOrganizationWebSiteField"
        :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.ORGANIZATION_WEBSITE, PassSectionsEnum.organization)"
      >
        <organization-website-input
          v-model="organization.website"
          :input-label="fieldTitle(OrganizationSectionFieldAliases.ORGANIZATION_WEBSITE, PassSectionsEnum.organization)"
          :input-hint="fieldHint(OrganizationSectionFieldAliases.ORGANIZATION_WEBSITE, PassSectionsEnum.organization)"
          :form="form"
          :errors="errors"
          :disabled="disabledWebsiteField"
        />
      </div>
      <div
        v-if="visibleContractFields"
        :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.CONTRACT_NUMBER, PassSectionsEnum.organization)"
      >
        <contract-number-input
          v-model="form.application.contract_number"
          :input-label="fieldTitle(OrganizationSectionFieldAliases.CONTRACT_NUMBER, PassSectionsEnum.organization)"
          :input-hint="fieldHint(OrganizationSectionFieldAliases.CONTRACT_NUMBER, PassSectionsEnum.organization)"
          :form="form"
          :errors="errors"
          :disabled="disabledInput"
        />
      </div>
      <div
        v-if="visibleContractFields"
        :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.CONTRACT_DATE_OF, PassSectionsEnum.organization)"
      >
        <contract-date-input
          v-model="form.application.contract_date"
          :input-label="fieldTitle(OrganizationSectionFieldAliases.CONTRACT_DATE_OF, PassSectionsEnum.organization)"
          :input-hint="fieldHint(OrganizationSectionFieldAliases.CONTRACT_DATE_OF, PassSectionsEnum.organization)"
          :form="form"
          :errors="errors"
          :disabled="disabledInput"
          :max-date="currentMomentDate.clone()"
        />
      </div>
      <div
        v-if="visibleContractFields"
        :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.CONTRACT_DATE_TO, PassSectionsEnum.organization)"
      >
        <contract-end-date-input
          v-model="form.application.contract_end_date"
          :input-label="fieldTitle(OrganizationSectionFieldAliases.CONTRACT_DATE_TO, PassSectionsEnum.organization)"
          :input-hint="fieldHint(OrganizationSectionFieldAliases.CONTRACT_DATE_TO, PassSectionsEnum.organization)"
          :form="form"
          :errors="errors"
          :disabled="disabledInput || form.application.contract_unlimited"
          :min-date="minDateContractEndDate"
        />
        <div slot="after">
          <label class="applicant-helpers flex-label">
            <input
              v-model="form.application.contract_unlimited"
              type="checkbox"
              :disabled="disabledInput"
              @change="clearContractEndDate"
            />
            &nbsp;
            Бессрочный
          </label>
        </div>
      </div>
      <div
        v-if="visibleContractFields"
        :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.CONTRACT_ORG_NAME, PassSectionsEnum.organization)"
      >
        <contract-org-name-input
          v-model="form.application.contract_org_name"
          :terminal-organizations="terminalOrganizations"
          :typeahead="typeaheadContractOrgName"
          :select-typeahead="selectTypeaheadContractOrgName"
          :input-label="fieldTitle(OrganizationSectionFieldAliases.CONTRACT_ORG_NAME, PassSectionsEnum.organization)"
          :input-hint="fieldHint(OrganizationSectionFieldAliases.CONTRACT_ORG_NAME, PassSectionsEnum.organization)"
          :form="form"
          :errors="errors"
          :disabled="disabledInput"
          @change-contract-organization="$emit('change-contract-organization', $event)"
        />
      </div>
      <div
        v-if="visibleContractFields"
        :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.CONTRACT_ORG_INN, PassSectionsEnum.organization)"
      >
        <contract-org-inn-input
          v-model="form.application.contract_org_inn"
          :input-label="fieldTitle(OrganizationSectionFieldAliases.CONTRACT_ORG_INN, PassSectionsEnum.organization)"
          :input-hint="fieldHint(OrganizationSectionFieldAliases.CONTRACT_ORG_INN, PassSectionsEnum.organization)"
          :form="form"
          :errors="errors"
          :disabled="disabledInput"
        />
      </div>
    </div>
    <application-documents-block
      :application="form.application"
      :applicationDocuments="computedDocuments"
      :form="form"
      :errors="errors"
    />
  </div>
</template>

<script>
// TODO Some fields have no purpose because they are needed for compatibility with the current state of the task 3092
import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import mainMixin from '@/common/mixins/mainMixin'
import OrganizationSubjectInput from '@/common/components/application/form-inputs/organization/OrganizationSubjectInput.vue'
import OrganizationNameInput from '@/common/components/application/form-inputs/organization/OrganizationNameInput.vue'
import OrganizationInnInput from '@/common/components/application/form-inputs/organization/OrganizationInnInput.vue'
import OrganizationAddressInput from '@/common/components/application/form-inputs/organization/OrganizationAddressInput.vue'
import OrganizationPhoneInput from '@/common/components/application/form-inputs/organization/OrganizationPhoneInput.vue'
import { Logger } from '@/common/helpers/Logger'
import { UserRoles } from '@/common/enums/UserRoles'
import InternalCommentBlock from '@/common/components/application/internalCommentBlock.vue'
import PermissionsEnum from '@/common/enums/PermissionsEnum'
import permissionsMixin from '@/common/mixins/PermissionsMixin'
import OrganizationDto from '@/common/classes/dto/OrganizationDto'
// import OrganizationFizAddressInput from '@/common/components/application/form-inputs/organization/OrganizationFizAddressInput.vue'
import OrganizationEmailInput from '@/common/components/application/form-inputs/organization/OrganizationEmailInput.vue'
import OrganizationWebsiteInput from '@/common/components/application/form-inputs/organization/OrganizationWebsiteInput.vue'
import ContractNumberInput from '@/common/components/application/form-inputs/pass/ContractNumberInput.vue'
import ContractDateInput from '@/common/components/application/form-inputs/pass/ContractDateInput.vue'
import ContractEndDateInput from '@/common/components/application/form-inputs/pass/ContractEndDateInput.vue'
import { OrganizationSectionFieldAliases } from '@/common/enums/ApplicationSectionFieldAliases'
import moment from 'moment-timezone'
import ContractOrgNameInput from '@/common/components/application/form-inputs/organization/ContractOrgNameInput.vue'
import ContractOrgInnInput from '@/common/components/application/form-inputs/organization/ContractOrgInnInput.vue'
import { OrganizationSubjects } from '@/enums/OrganizationSubjects'
import PassSectionsEnum from '@/common/enums/PassSectionsEnum'
import ApplicationDocumentsBlock from '@/common/components/application/ApplicationDocumentsBlock'

export default {
  name: 'OrganizationFormBlock',
  mixins: [
    mainMixin,
    applicationFormMixin,
    applicationFormContextMixin,
    permissionsMixin
  ],

  components: {
    ApplicationDocumentsBlock,
    ContractOrgInnInput,
    ContractOrgNameInput,
    ContractEndDateInput,
    ContractDateInput,
    ContractNumberInput,
    OrganizationWebsiteInput,
    OrganizationEmailInput,
    // OrganizationFizAddressInput,
    InternalCommentBlock,
    OrganizationSubjectInput,
    OrganizationNameInput,
    OrganizationInnInput,
    OrganizationAddressInput,
    OrganizationPhoneInput
  },

  data: () => ({
    locationName: 'all',
    locations: [],
    nationalityListIsOpen: false,
    prevAddress: ''
  }),

  model: {
    prop: 'organization',
    event: 'change-organization'
  },

  props: {
    applicationDocuments: {
      type: Array,
      default: () => []
    },

    applicationPurposes: {
      type: [Array, Object],
      default: () => []
    },

    cfgFormFields: {
      type: [Array, Object],
      default: () => []
    },

    organization: {
      type: Object,
      required: true
    },

    organizationDisabled: {
      type: Boolean,
      default: () => false
    },

    organizationSubjects: {
      type: Array,
      default: () => []
    },

    nationalitiesList: {
      default: []
    },

    organizationSubjectsResidency: {
      default: []
    },

    timezone: {
      type: String,
      default: 'Europe/Moscow'
    },

    terminalOrganizations: {
      type: Array,
      default: () => []
    },

    organizationDocuments: {
      type: Array,
      default: () => []
    }
  },

  created() {
    if (this.isNew) {
      this.organization.authority_of_manager = 'with-authority'
      this.organization.director_name = ''
      this.organization.position_of_manager = ''
    }

    if (this.organization.inn && (this.isNew || this.isDuplicate) && this.form.organization.nationality_id === 182) {
      this.getOrganizationParty(this.organization.inn, { kpp: this.organization.kpp })
        .then(result => {
          result = result ?? []
          const firstSuggestion = result[0] ?? {}

          if (!firstSuggestion) {
            return
          }

          this.prevAddress = firstSuggestion.address ?? ''
          if (firstSuggestion.is_legal_manager) {
            this.organization.authority_of_manager = 'with-authority'
            this.organization.position_of_manager = ''
            this.organization.director_name = ''
            this.organization.is_legal_manager = true

            return
          }
          this.organization.authority_of_manager = 'without-authority'
          this.organization.director_name = firstSuggestion.director_name ?? ''
          this.organization.position_of_manager = firstSuggestion.position_of_manager ?? ''
          this.organization.is_legal_manager = false
          this.$store.dadataManagerName = firstSuggestion.director_name ?? ''
          this.$store.dadataManagerPosition = firstSuggestion.position_of_manager ?? ''
        })
    }
  },

  computed: {
    PassSectionsEnum() {
      return PassSectionsEnum
    },

    OrganizationSectionFieldAliases() {
      return OrganizationSectionFieldAliases
    },

    computedDocuments() {
      for (const document of this.organizationDocuments) {
        if (document.document.short_name === 'contract') {
          return [document]
        }
      }
      return []
    },

    organizationNameInputLabel() {
      return this.isEntityOrganizationSubject || this.isGkoOrganizationSubject || this.isTerminalSubject || this.isForeignSubject
        ? 'Наименование организации'
        : 'Фамилия, имя, отчество'
    },

    applicationPurpose() {
      return this.applicationPurposes[this.form.application.application_group_purpose_id]
    },

    currentMomentDate() {
      return moment().tz(this.timezone)
    },

    disabledBySystem() {
      return Boolean(this.disabledInput || this.organizationDisabled)
    },

    disabledOrganizationFields() {
      return Boolean(this.disabledBySystem || this.isTerminalSubject)
    },

    disabledForUserWithOrganization() {
      return Boolean(this.user?.organization_id)
    },

    disabledSubject() {
      return Boolean(this.disabledBySystem || this.disabledForUserWithOrganization)
    },

    disabledName() {
      if (this.disabledOrganizationFields) {
        return true
      }

      if (this.isFizOrganizationSubject) {
        return false
      }

      return this.disabledForUserWithOrganization
    },

    disabledInn() {
      return Boolean(this.disabledOrganizationFields || this.disabledForUserWithOrganization || this.isForeignSubject)
    },

    disabledAddressField() {
      return Boolean(this.disabledOrganizationFields || this.isFizOrganizationSubject)
    },

    disabledPhone() {
      return Boolean(this.disabledBySystem)
    },

    disabledEmail() {
      return Boolean(this.disabledBySystem)
    },

    disabledWebsiteField() {
      return Boolean(this.disabledOrganizationFields || this.isFizOrganizationSubject)
    },

    canShowInternalComment() {
      return this.hasPermission(PermissionsEnum.canUseInternalComment) && this.isView
    },

    iconsPath() {
      return process.env.BASE_URL + 'img/icons/countries/'
    },

    nationalities() {
      const nationalitiesIds = [
        ...new Set(this.organizationSubjectsResidency.map((value) => Number(value.nationality_id)))
      ]

      return this.nationalitiesList.filter(nationality => nationalitiesIds.includes(nationality.id))
    },

    selectedNationality() {
      return this.nationalities.find(nationality => nationality.id === this.form.organization.nationality_id) ??
        this.nationalities.find(nationality => nationality.iso2 === 'RU')
    },

    selectedNationalityImage() {
      return this.iconsPath + this.selectedNationality.iso2 + '.svg'
    },

    visibleContractFields() {
      return this.isCurrentContractFieldsDisplay &&
        !this.isTerminalSubject &&
        !this.isGkoOrganizationSubject
    },

    visibleOrganizationSubjectField() {
      return this.fieldVisible(OrganizationSectionFieldAliases.ORGANIZATION_SUBJECT, PassSectionsEnum.organization)
    },

    visibleOrganizationNameField() {
      return this.fieldVisible(OrganizationSectionFieldAliases.ORGANIZATION_NAME, PassSectionsEnum.organization)
    },

    visibleOrganizationInnField() {
      return this.fieldVisible(OrganizationSectionFieldAliases.ORGANIZATION_INN, PassSectionsEnum.organization)
    },

    visibleOrganizationAddressField() {
      return this.fieldVisible(OrganizationSectionFieldAliases.ORGANIZATION_ADDRESS, PassSectionsEnum.organization)
    },

    visibleOrganizationPhoneField() {
      return this.fieldVisible(OrganizationSectionFieldAliases.ORGANIZATION_PHONE, PassSectionsEnum.organization)
    },

    visibleOrganizationEmailField() {
      return this.fieldVisible(OrganizationSectionFieldAliases.ORGANIZATION_EMAIL, PassSectionsEnum.organization)
    },

    visibleOrganizationWebSiteField() {
      return this.fieldVisible(OrganizationSectionFieldAliases.ORGANIZATION_WEBSITE, PassSectionsEnum.organization)
    },

    minDateContractEndDate() {
      return this.currentMomentDate.clone()
    }
  },

  methods: {
    cleanContactFields() {
      // this.organization.phone = null; TODO phone widget steal input focus
      this.organization.email = null;
      this.organization.website = null;
    },

    cleanPrevValues() {
      this.prevManagerName = null
      this.prevManagerPosition = null
      this.prevAddress = null
    },

    change(inputName) {
      Logger.log(`Changed ${inputName}`)
      this.$emit('change-organization', this.organization)
    },

    changeNationality(nationality) {
      const organization = Object.assign({}, this.organization, { nationality_id: nationality.id })
      Logger.log(`Changed nationality ${nationality.id}!`)
      this.prevAddress = this.organization.address
      this.prevManagerName = this.organization.director_name
      this.prevManagerPosition = this.organization.position_of_manager
      this.$emit('change-organization', organization)
    },

    hidePersonalOrganizationFields() {
      if (this.organization.subject_id !== OrganizationSubjects.Terminal) {
        return
      }

      this.form.visitors.forEach(visitor => {
        if (visitor.personal) {
          visitor.personal.require_other_organization = false
        }
      })
    },

    switchLocationName() {
      this.locationName = this.locationName !== 'all' ? 'all' : this.configuration?.find_region ?? 'nw'
    },

    /**
     * @param {TypeaheadOrganization} item
     */
    async selectTypeaheadOrganization(item) {
      if (this.isFizOrganizationSubject) {
        if (item instanceof Object) {
          const organization = Object.assign({}, new OrganizationDto({}), this.organization, {
            name: item.value,
            short_name: item.short_name
          })
          this.$emit('change-organization', organization)
        }

        return
      }

      if (item === null) {
        item = this.organization.innData
      }

      if (item instanceof Object) {
        item.authority_of_manager = 'with-authority'
        await this.getOrganizationParty(item.inn, { kpp: item.kpp })
          .then(result => {
            result = result ?? []
            const firstSuggestion = result[0] ?? {}

            if (firstSuggestion) {
              item.authority_of_manager = 'without-authority'
              item.director_name = firstSuggestion.director_name ?? ''
              item.position_of_manager = firstSuggestion.position_of_manager ?? ''
              item.is_legal_manager = false
              if (firstSuggestion.is_legal_manager) {
                item.authority_of_manager = 'with-authority'
                item.position_of_manager = ''
                item.director_name = ''
                item.is_legal_manager = true
              }
            }
          })

        const organization = Object.assign({}, new OrganizationDto({}), this.organization, {
          inn: item.inn,
          kpp: item.kpp,
          innData: item.inn,
          address: item.address ?? null,
          authority_of_manager: item.authority_of_manager,
          position_of_manager: item.position_of_manager ?? null,
          director_name: item.director_name ?? null,
          name: item.org_name,
          short_name: item.short_name,
          is_legal_manager: item.is_legal_manager
        })
        this.$emit('change-organization', organization)
        this.prevAddress = item.address ?? ''
      }
    },

    typeaheadOrganizationAddress(query, done) {
      this
        .typeaheadAddresses(query, done, false, 'organization')
        .then(() => this.resetTypeaheadActiveIndex(this.$refs.organizationName.$refs.addressRef))
    },

    clearContractEndDate() {
      if (this.form.application.contract_unlimited) {
        this.form.application.contract_end_date = null
      }
    },

    /**
     * @param {TypeaheadOrganization} item
     */
    selectTypeaheadContractOrgName(item) {
      if (item === null || !(item instanceof Object)) {
        return
      }

      const organization = new OrganizationDto({
        inn: item.inn,
        name: item.org_name,
        short_name: item.short_name
      })
      this.$emit('change-contract-organization', organization)
    }
  },

  watch: {
    'organization.inn': function (inn) {
      this.form.application.documents = []
      this.checkInnControlSum()
    },
    'organization.name': function (name) {
      this.checkInnControlSum()
    }
  }
}
</script>
